export function centsToReais(value: any, prefix = true): string | number {
  if (!value) return 0

  const brl = Number(value) / 100

  const withPrefix = brl.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  const withoutPrefix = brl.toLocaleString('pt-br', { minimumFractionDigits: 2 })

  return prefix ? withPrefix : withoutPrefix
}
